import { Box, useTheme, Link } from "@mui/material";
import { useEffect } from "react";
import { useContext } from "react";
import { ColorModeContext, tokens } from "../../../styles/theme";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import * as sweetalert from "sweetalert";
import { Select } from "@material-ui/core";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import axios from "axios";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
const Topbar = () => {
  const navigate = useNavigate();
  const [Firstname, setFirstname] = React.useState([]);
  const [accounts, setAccount] = React.useState([]);
  useEffect(() => {},[accounts,Firstname])
  const locale = localStorage.getItem("is loggedIn");
  const admin = localStorage.getItem("staff_type");
  useEffect(() => {
    setFirstname('');
    setAccount('');
    axios
    .get(`${BaseUrl}/api/getSignupRequest`, {
        withCredentials: true,
      })
      .then((res) => {
        setFirstname(res.data.data.first_name + " " + res.data.data.last_name);
      })
      .catch((err) => {});
      axios
      .get(`${BaseUrl}/api/getmyfundBalance`, {
        withCredentials: true,
      })
      .then((res) => { 
        setAccount(res.data.data.amount);  
      })
      .catch((err) => {});
    },[locale]);
    
   
    const handleLogout = () => {
    Cookies.remove("jwt");
    
    localStorage.removeItem("is loggedIn");
    localStorage.removeItem("staff_type");
    sweetalert("تم تسجيل الخروج بنجاح", {
      className: "alert-div",
      button: {
        text: "تم",
      },
    });
    setFirstname('');
    setAccount('');
    navigate("/");
  };
  const handlereset = () => {
    navigate("/reset-password-account");
  };
  const handleProfile = () => {
    navigate("/profile");
  };

  
 
  if (locale === "true") {
    return (
      <Box>
        <div className="navbar">
        {locale === "true" ?(
          <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
          <img src="../logo-white.png" id="logo" alt="logo"></img>
          <span className="accounts" style={{color:'#fff', fontSize:'20px'}}>رصيدي :</span>
          <span className="accounts" style={{color:'white', fontSize:'20px', paddingRight:'10px'}}>
          {admin && admin ==="Admin"?(
            <>&infin;</>
          ): admin !== "Admin" ?(
            <>  {accounts}</>
          ):(<></>)}
          </span>
        </div>
        ):(
          <></>
        )}
        

          <div className="sign-user">
            <Select className="selectuser" value={1}>
              <MenuItem value={1}>
              
                <p style={{color:"#fff"}}>{Firstname}</p>
              </MenuItem>
              <MenuItem value={2}>
                <Link onClick={handlereset}>تغيير كلمة المرور</Link>
              </MenuItem>
              <MenuItem value={3}>
                <Link onClick={handleProfile}>حسابي</Link>
              </MenuItem>
              <MenuItem value={4}>
                <Link onClick={handleLogout}>تسجيل الخروج</Link>
              </MenuItem>
            </Select>
          </div>
        </div>
      </Box>
    );
  }
};

export default Topbar;
